// Youssef Selkani
// 2019

import React, { Component } from "react";
import "../App.css";
import { Container, Form, Button, TextArea } from 'semantic-ui-react';

export default class Contact extends Component {
  render() {
    return (
      <Container className='div1'>
        <div className='div3'>

          <div>
            <Form enctype="multipart/form-data" action="https://getform.io/f/68a50b3f-4810-466b-addc-27465979e137" method="POST">
              <Form.Field required>
                <label>Full name</label>
                <input type="text" name="name" />
              </Form.Field>
              <Form.Field required>
                <label>Email address</label>
                <input type="text" name="name" />
              </Form.Field>
              <Form.Field required>
                <label>Message</label>
                <TextArea rows={5} type="text" name="message" />
              </Form.Field>
              <Button size='small' type="submit">Send</Button>
            </Form>
          </div>
        </div>
      </Container>
    );
  }
}